import keyMirror from "ramda-extension/es/keyMirror";
export const VALID = 'VALID';
export const severity = keyMirror({
    REQUIRED: 'REQUIRED',
    ERROR: 'ERROR',
    WARNING: 'WARNING'
});
export const validationCombination = keyMirror({
    ALL: null,
    R: null,
    E: null,
    RE: null
});
export const group = keyMirror({
    PRETRANSITION: null,
    POSTTRANSITION: null
});
export const groupPath = {
    [group.PRETRANSITION]: 'preTransitionValidations',
    [group.POSTTRANSITION]: 'postTransitionValidations'
};
export const transitionDirection = {
    BACKWARD: 'backward',
    FORWARD: 'forward'
};
